import l10n from "@/services/l10n";
import AccessControl from "@/services/AccessControl";

import { USER_GROUP_PERSON } from "@/constants";

export default [
  {
    name: "playlists",
    path: "/playlists",
    icon: "playlists",
    meta: { title: l10n("MY_PLAYLISTS") },
    beforeEnter: AccessControl.route(USER_GROUP_PERSON),
    component: () =>
      import(
        /* webpackChunkName: "playlists" */ "@/pages/Playlists/Playlists.vue"
      )
  },
  {
    name: "playlistEdit",
    path: "/playlists/:id/edit",
    icon: "playlists",
    meta: { title: l10n("EDIT_PLAYLIST") },
    beforeEnter: AccessControl.route(USER_GROUP_PERSON),
    component: () =>
      import(
        /* webpackChunkName: "editor" */ "@/pages/Playlists/PlaylistEdit.vue"
      )
  },
  {
    name: "playlist",
    path: "/playlists/:id",
    icon: "playlists",
    meta: { title: l10n("PLAYLIST") },
    beforeEnter: AccessControl.route(USER_GROUP_PERSON),
    component: () =>
      import(
        /* webpackChunkName: "fullview" */ "@/pages/Playlists/Playlist.vue"
      )
  }
];
